import { useCallback, useRef } from 'react';

import type { ZuubManualCheckListPatient } from '@/@types/zuub/contracts';

import { PatientCoverageDataCard } from './PatientCoverageDataCard';
import { RecentVerificationsCard } from './RecentVerificationsCard';
import { VerificationInformationForm } from './VerificationInformationForm';
import { useRunVerification } from './useRunVerification';

export const RunVerificationTab = () => {
  const coverageSectionRef = useRef<HTMLDivElement>(null);

  const {
    selectedPatient,
    mergedEntries,
    selectedPatientId,
    handleSelectPatient,
    isListLoading,
    isListError,
    formFillValues,
    checkDuplicate,
    handleVerifySubmit,
    isSubmitting,
    currentPage,
    totalPages,
    handlePageChange,
  } = useRunVerification();

  const handleSelectPatientWithScroll = useCallback(
    (patient: ZuubManualCheckListPatient) => {
      handleSelectPatient(patient);
      coverageSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    },
    [handleSelectPatient],
  );

  return (
    <div className="vai-flex vai-w-full vai-flex-col vai-gap-6 vai-overflow-y-auto vai-h-full vai-pb-6">
      <div className="vai-flex vai-min-h-0 vai-flex-shrink-0 vai-gap-6">
        <div className="vai-min-w-0 vai-flex-[0_1_60%] vai-rounded-lg vai-border vai-border-gray-200 vai-bg-white vai-p-6 vai-shadow-sm">
          <VerificationInformationForm
            formFillValues={formFillValues}
            checkDuplicate={checkDuplicate}
            onSubmit={handleVerifySubmit}
            isSubmitting={isSubmitting}
          />
        </div>
        <div className="vai-flex vai-min-w-0 vai-flex-[0_1_40%] vai-flex-col">
          <RecentVerificationsCard
            patients={mergedEntries}
            isLoading={isListLoading}
            isError={isListError}
            onSelectPatient={handleSelectPatientWithScroll}
            selectedPatientId={selectedPatientId}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      <div ref={coverageSectionRef} className="vai-w-full vai-flex-shrink-0">
        <PatientCoverageDataCard selectedPatient={selectedPatient} />
      </div>
    </div>
  );
};
